import React from 'react';
import '../Main/Main.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import SupportTicketsPanel from '../../Components/Admin/SupportTickets/SupportTickets';

export default function SupportTickets() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <SupportTicketsPanel />
                </div>
            </section>
        </div>
    );
}
